import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

import { Paper, Button } from '../../Common/Components';

export interface MerchantLoginEmailProps {
  onNext: (email: string) => void;
  error?: string;
  clearError: () => void;
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'grid',
  },
  inputWrapper: {
    width: '100%',
    marginBottom: '39px',
  },
  input: {
    color: theme.palette.grey[600],
    borderRadius: '16px',
    borderColor: theme.palette.grey[600],
    borderWidth: '1px',

    '& input:-internal-autofill-selected,input:-webkit-autofill': {
      boxShadow: `0 0 0px 50px ${theme.palette.background.paper} inset`,
    },

    '&:hover + fieldset': {
      borderColor: theme.palette.grey[600],
    },
  },
  inputLabel: {
    color: theme.palette.grey[600],
  },
  header: {
    display: 'grid',
    gridGap: '16px',
    marginBottom: '40px',
  },
}));

const MerchantRecoverPasswordEmailView: React.FC<MerchantLoginEmailProps> = ({
  onNext,
  error,
  clearError,
}) => {
  const classes = useStyles();
  const [email, setEmail] = useState('');

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onNext(email);
  };

  const onEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearError();
    setEmail(e.target.value);
  };

  return (
    <Paper className={classes.container}>
      <div className={classes.header}>
        <Typography variant="h1" color="primary">
          Did you forget your password?
        </Typography>
      </div>

      <form onSubmit={onSubmit}>
        <TextField
          id="email"
          label="Enter Email"
          name="email"
          type="email"
          variant="outlined"
          autoComplete="email"
          className={classes.inputWrapper}
          value={email}
          focused={false}
          onChange={onEmailChange}
          InputProps={{ className: classes.input }}
          InputLabelProps={{ className: classes.inputLabel }}
          error={!!error}
          helperText={error}
        />

        <Button className="wide" type="submit">
          Reset Password
        </Button>
      </form>
    </Paper>
  );
};

export default MerchantRecoverPasswordEmailView;
